var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g2, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecklistEndReprove = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 150,
  height: 150,
  viewBox: "0 0 150 150",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M80.52 136.76C110.763 136.76 135.28 134.02 135.28 130.64C135.28 127.26 110.763 124.52 80.52 124.52C50.2769 124.52 25.76 127.26 25.76 130.64C25.76 134.02 50.2769 136.76 80.52 136.76Z",
  fill: "#E2E2E2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.13,
  d: "M135.6 12.7354H14.3999C11.0862 12.7354 8.3999 15.4216 8.3999 18.7354V92.4154C8.3999 95.7291 11.0862 98.4154 14.3999 98.4154H135.6C138.914 98.4154 141.6 95.7291 141.6 92.4154V18.7354C141.6 15.4216 138.914 12.7354 135.6 12.7354Z",
  fill: "#82EA5B"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M135.615 13.0049H14.1748C10.9936 13.0049 8.41479 15.5837 8.41479 18.7649V91.6549C8.41479 94.836 10.9936 97.4149 14.1748 97.4149H135.615C138.796 97.4149 141.375 94.836 141.375 91.6549V18.7649C141.375 15.5837 138.796 13.0049 135.615 13.0049Z",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 83.3447H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 69.2744H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 55.21H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 41.1396H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.41479 27.0703H141.375",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.215 13.0049V97.4149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.0547 13.0049V97.4149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.8948 13.0049V97.4149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.7349 13.0049V97.4149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.5747 13.0049V97.4149",
  stroke: "#444444",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.4651 41.9803C49.4001 41.0653 48.2251 38.6103 49.9201 35.9553C51.1951 33.7053 52.6101 33.3103 54.2701 33.8403C53.8501 32.1003 52.2201 30.6203 55.3651 26.6503C59.1101 22.3053 66.6851 19.6903 67.2201 25.8453C68.4051 18.5203 77.5201 15.6453 83.6451 19.8853C87.5201 21.7753 89.2051 26.7703 87.2901 30.2653C88.8201 29.5453 97.2151 30.1953 98.8001 32.6453C100.545 34.3353 101.345 36.2703 100.845 37.3803C100.345 38.4853 99.7051 40.2853 96.6951 40.7803C81.2251 41.4203 66.8851 41.9053 51.4651 41.9803Z",
  fill: "#8FFFD1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.4451 45.7402C53.4451 45.7402 53.1351 46.7002 53.1851 47.0502C53.2351 47.4002 53.9551 48.0102 53.8301 47.0902C53.7051 46.1702 53.4451 45.7402 53.4451 45.7402Z",
  fill: "#8FFFD1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.5101 44.7998C58.5101 44.7998 58.0951 45.8548 57.9501 46.4098C57.8051 46.9648 58.4701 48.1948 58.7501 47.1198C59.0251 45.9498 58.8751 45.1448 58.5051 44.7998H58.5101Z",
  fill: "#8FFFD1"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.045 50.495C58.045 50.495 58.015 51.595 58.115 51.975C58.215 52.355 58.75 52.59 58.715 51.89C58.635 51.13 58.615 50.37 58.045 50.495Z",
  fill: "#8FFFD1"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.0499 44.6847C65.7949 44.8897 65.5549 47.1447 66.2949 47.0697C66.7049 46.9947 66.8249 46.4297 66.5549 45.9247C66.2849 45.4197 66.0499 44.6797 66.0499 44.6797V44.6847Z",
  fill: "#8FFFD1"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.3149 49.9697C70.3149 49.9697 70.1699 51.0297 70.1549 51.3997C70.1449 51.7747 70.6349 52.7097 70.9449 52.0597C71.2549 51.4097 71.0049 51.3497 70.8349 50.9647C70.6649 50.5797 70.3099 49.9697 70.3099 49.9697H70.3149Z",
  fill: "#8FFFD1"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.1701 44.3545C74.1701 44.3545 74.0251 45.3895 73.9551 45.9545C73.8851 46.5195 74.4901 47.7145 74.6951 46.6745C74.9001 45.6295 74.6501 45.6995 74.5951 45.2345C74.5401 44.7695 74.1701 44.3545 74.1701 44.3545Z",
  fill: "#8FFFD1"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.2751 44.9102C80.2751 44.9102 79.9451 45.8552 79.9701 46.4502C79.9951 47.0402 80.3301 47.4952 80.6001 47.1002C81.1651 46.4152 80.7351 45.2602 80.2751 44.9102Z",
  fill: "#8FFFD1"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.28 49.1846C77.28 49.1846 77.115 49.8446 77.055 50.2396C76.995 50.6346 77.195 51.5396 77.55 51.2496C78.135 50.9496 77.355 49.3596 77.28 49.1846Z",
  fill: "#8FFFD1"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.275 48.8945C84.165 49.1045 83.63 51.3195 84.335 51.2945C84.71 51.2145 84.885 50.9595 84.8 50.4445C84.715 49.9345 84.525 49.7595 84.47 49.4995C84.41 49.2395 84.275 48.8945 84.275 48.8945Z",
  fill: "#8FFFD1"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.0151 44.1602C86.9101 44.5302 86.5001 46.3402 87.1201 46.5902C87.5051 46.6752 87.5251 46.3152 87.5401 45.9152C87.5801 45.3752 87.1051 44.4952 87.0151 44.1602Z",
  fill: "#8FFFD1"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.2499 48.0898C90.0849 48.2948 89.6349 50.9848 90.4499 50.6898C90.9999 50.4398 90.9999 50.3448 90.8449 49.6798C90.6849 49.0098 90.2499 48.0898 90.2499 48.0898Z",
  fill: "#8FFFD1"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.7001 43.165C92.7001 43.165 92.6551 43.89 92.6251 44.715C92.5901 45.54 93.4151 45.975 93.3601 45.08C93.3051 44.185 92.7001 43.165 92.7001 43.165Z",
  fill: "#8FFFD1"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.3852 48.0752C94.7752 49.5202 95.7052 50.2402 95.7502 49.2252C95.7652 48.4502 95.3852 48.0752 95.3852 48.0752Z",
  fill: "#8FFFD1"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.105 33.6698C52.275 33.0948 51.45 33.7398 50.47 35.1748C48.59 37.6648 48.345 40.1598 50.89 42.1198C51.03 42.2298 51.215 42.0198 51.07 41.9048C48.65 40.0498 48.915 37.6948 50.7 35.3398C51.75 33.7748 52.53 33.3848 54.39 34.0548C55.235 35.3148 55.77 34.3598 54.665 33.8698C54.3 33.6248 54.115 33.1748 53.99 32.7548C53.06 29.0748 55.38 25.9098 58.62 23.9548C61.19 22.4098 65.855 21.1498 66.855 24.8298C66.96 25.2998 66.91 26.2648 66.91 26.2648C66.895 26.4298 67.155 26.4598 67.19 26.3048C69.54 12.2748 91.93 17.8848 87.3 30.1448C86.885 30.1498 86.9851 30.5448 87.37 30.4198C89.0201 30.0648 90.765 30.1148 92.435 30.3298C93.66 30.5148 94.895 30.7048 96.06 31.1398C98.17 31.9498 101.765 34.7898 100.645 37.6048C99.09 41.1648 95.75 40.6098 92.56 40.8448C78.82 41.1748 65.11 41.8998 51.355 41.8048C57.87 42.7848 66.9 41.6348 74.25 41.6098C81.635 41.3248 89.215 41.4998 96.555 40.8698C98.42 40.5948 99.97 39.8698 100.905 37.7148C102.12 34.7598 98.405 31.7448 96.16 30.8848C93.455 29.9748 90.505 29.6898 87.68 30.0548C91.88 17.4198 70.02 12.5748 67.19 25.1798C65.86 17.4298 50.065 26.0148 54.11 33.6698H54.105Z",
  fill: "#8FFFD1"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.4299 44.7903C57.9699 45.6503 57.4199 46.7903 58.0899 47.6953C58.2699 47.8703 58.4749 47.8853 58.6449 47.6553C59.1649 46.8403 59.0999 45.6903 58.7499 44.8453C58.7099 44.7553 58.6649 44.6603 58.7099 44.5753C58.7599 44.2003 58.2899 44.3903 58.4299 44.7903ZM58.5699 45.1053C58.2449 45.7803 57.7199 46.9203 58.3599 47.5453C58.8999 46.8903 58.7599 45.8503 58.5699 45.1053Z",
  fill: "#8FFFD1"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.0351 44.5145C65.4701 44.6295 65.6201 46.2395 65.7601 46.6795C66.0851 47.6145 66.9201 47.1995 66.7801 46.3245C66.7351 46.0295 66.5851 45.7695 66.5001 45.4845C66.3801 45.2395 66.3801 44.4845 66.0351 44.5145ZM66.0351 44.8695C65.8501 45.3695 65.8951 46.1545 66.0351 46.5995C66.2101 47.2095 66.6101 46.8345 66.5001 46.3645C66.3601 45.8595 66.1701 45.3845 66.0351 44.8695Z",
  fill: "#8FFFD1"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.3251 44.2397C74.5401 44.0797 74.1801 43.8197 74.0701 44.1147C73.9051 45.0997 73.5251 46.2447 74.0951 47.1197C74.6251 47.6247 74.9001 46.5197 74.8651 46.1297C74.8651 45.5097 74.6101 44.9397 74.4501 44.3547C74.4401 44.2947 74.3851 44.2497 74.3251 44.2447V44.2397ZM74.2451 44.6747C74.1501 45.3997 73.8601 46.3347 74.3451 46.9697C74.8301 46.2897 74.4901 45.3847 74.2451 44.6747Z",
  fill: "#8FFFD1"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.1651 44.745C80.0701 45.07 79.7701 46.165 79.9001 46.795C79.9701 47.425 80.8401 47.6 80.9101 46.845C80.9951 46.29 80.7851 45.35 80.7151 45.2C80.6801 45.11 80.4851 44.93 80.4451 44.79C80.6051 44.54 80.1651 44.48 80.1601 44.75L80.1651 44.745ZM80.3501 45.16C80.2401 45.635 80.0551 46.35 80.2201 46.865C80.4601 47.315 80.6851 46.955 80.6551 46.575C80.6201 45.915 80.5851 45.425 80.3501 45.16Z",
  fill: "#8FFFD1"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.88 43.8902C86.78 43.8952 86.72 44.0202 86.78 44.1002C86.82 44.8452 86.11 46.1602 87.015 46.7102C87.85 47.0202 87.67 45.4902 87.57 45.1002C87.415 44.6952 87.165 44.3052 87.165 43.8702C87.165 43.6802 86.855 43.7002 86.88 43.8902ZM87.03 44.5502C86.99 44.9502 86.505 46.2752 87.23 46.4852C87.585 45.7902 87.27 45.1052 87.03 44.5502Z",
  fill: "#8FFFD1"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.68 42.8344C92.46 43.5494 92.35 44.5294 92.52 45.2894C92.705 45.8794 93.45 45.9594 93.515 45.2644C93.605 44.3994 92.975 43.6294 92.965 42.7744C92.955 42.5594 92.625 42.6244 92.68 42.8344ZM92.815 43.5544C92.765 44.1644 92.51 45.0044 92.975 45.4644C93.125 45.5394 93.21 45.4444 93.23 45.2444C93.285 44.6544 92.98 44.1044 92.815 43.5544Z",
  fill: "#8FFFD1"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.04 48.1798C89.815 48.6998 89.78 49.8998 89.965 50.4698C90.4 51.4948 91.51 50.5548 90.815 49.1498C90.705 48.8398 90.6 48.5248 90.6 48.1898C90.6 48.1148 90.535 48.0498 90.46 48.0498C90.1 48.1648 90.495 48.9648 90.55 49.2348C90.675 49.6548 90.96 50.2248 90.575 50.5598C90.415 50.6798 90.3 50.5948 90.235 50.3848C90.065 49.8648 90.095 48.7598 90.3 48.2848C90.375 48.1198 90.105 48.0148 90.04 48.1798Z",
  fill: "#8FFFD1"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.2752 48.5846C82.8802 51.5996 85.0702 52.2946 84.9102 50.3746C84.8252 49.8496 84.4452 49.2296 84.5352 48.7046C84.6152 48.5446 84.3501 48.4296 84.2801 48.5896L84.2752 48.5846ZM84.3002 49.2796C83.6752 50.9996 84.6751 51.8896 84.6301 50.4246C84.5501 50.0646 84.3952 49.6696 84.3002 49.2796Z",
  fill: "#8FFFD1"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.44 49.0148C77.495 48.8348 77.2 48.7648 77.165 48.9498C77.06 49.6248 76.515 51.1548 77.38 51.4248C77.755 51.4248 77.985 51.0798 77.9 50.6398C77.785 50.1198 77.625 49.6648 77.545 49.1298C77.535 49.0748 77.495 49.0298 77.44 49.0148ZM77.33 49.5248C77.245 50.0148 77.085 50.6248 77.305 51.0898C77.51 51.2898 77.695 50.9298 77.625 50.6998C77.535 50.2948 77.415 49.9248 77.33 49.5298V49.5248Z",
  fill: "#8FFFD1"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70.5601 49.7298C70.1201 49.0298 69.9851 51.5998 70.0601 51.8248C70.2001 52.9148 71.2651 52.2498 71.1401 51.5048C71.0551 50.8798 70.6101 50.3598 70.5601 49.7298ZM70.4201 50.3798C70.3751 50.6648 70.1001 52.3998 70.6601 52.0598C71.1551 51.6048 70.5951 50.8748 70.4201 50.3798Z",
  fill: "#8FFFD1"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.3049 45.5145C53.0949 45.6345 53.0099 46.9295 53.0299 47.2295C53.0749 47.5245 53.4549 47.9195 53.7649 47.7845C54.1349 47.5095 53.9249 46.9095 53.8099 46.4945C53.7099 46.1695 53.5849 45.8445 53.5849 45.5395C53.5849 45.3745 53.3249 45.3545 53.3049 45.5195V45.5145ZM53.4099 46.1445C53.3649 46.5845 53.0649 47.3245 53.6399 47.5345C53.7949 47.1095 53.5199 46.5845 53.4099 46.1445Z",
  fill: "#8FFFD1"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.9401 50.2753C57.8151 50.6953 57.6701 51.9103 58.1351 52.3553C58.4201 52.5803 58.6101 52.5703 58.7401 52.3103C58.8751 51.6403 58.7251 50.8653 58.4001 50.4353C58.2351 50.3053 58.1701 49.8853 57.9201 49.9453C57.7701 50.0253 57.8801 50.1803 57.9451 50.2803L57.9401 50.2753ZM58.1601 50.5803C58.1201 51.0153 57.9551 52.0003 58.4651 52.2353C58.5901 51.5553 58.4451 50.9803 58.1601 50.5803Z",
  fill: "#8FFFD1"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.37 47.5552C95.16 47.4852 95.13 47.7252 95.235 47.8552C94.255 50.5952 96.76 50.6502 95.54 47.8502C95.58 47.7402 95.7 47.5952 95.55 47.5152C95.485 47.4802 95.405 47.5052 95.37 47.5602V47.5552ZM95.4 48.3102C95.3 48.7552 95.16 49.2302 95.465 49.6652C95.84 49.3402 95.465 48.6652 95.4 48.3102Z",
  fill: "#8FFFD1"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M99.97 46.7246H97.375L98.24 48.2646L99.97 46.7246Z",
  fill: "#92410F"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_31451_21123",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 61,
  y: 57,
  width: 2,
  height: 3
}, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6501 57.7051L61.425 59.0851L62.6501 57.7051Z",
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_31451_21123)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.6501 57.7051H61.425V59.0901H62.6501V57.7051Z",
  fill: "#EBB990"
}))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M50.56 86.5699C52.955 84.6749 54.98 81.8749 55.385 78.8099C55.44 78.3799 54.765 78.3849 54.705 78.8099C54.325 81.6849 52.315 84.3199 50.08 86.0949C49.74 86.3649 50.22 86.8399 50.56 86.5749V86.5699Z",
  fill: "#ACACAC"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M92.1001 54.5152L94.1901 53.1152L92.9901 55.9602L92.1001 54.5152Z",
  fill: "#A3642B"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M101.645 56.145L95.1599 59.355L92.0849 54.545L90.3449 54.6C88.9699 54.535 89.0849 52.99 89.0849 52.015C89.0849 51.26 89.0849 50.505 89.0849 49.75C88.8049 49.805 88.4499 49.83 88.3049 49.59C88.2099 49.435 88.2499 49.235 88.2949 49.06C88.5949 47.835 88.8949 46.605 89.3649 45.435C89.8599 44.195 90.4999 42.415 91.9899 42.275C93.7149 42.11 95.3999 42.79 96.9899 43.485C98.4849 44.14 99.2149 45.51 99.4049 47.105C99.4949 47.85 99.4299 48.61 99.2199 49.33C99.1599 49.53 98.2249 51.32 98.1949 51.275L101.64 56.145",
  fill: "#C1813E"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M91.2398 47.6195C91.2498 47.7845 91.1198 47.9295 90.9548 47.9395C90.7898 47.9495 90.6448 47.8195 90.6348 47.6545C90.6248 47.4895 90.7548 47.3445 90.9198 47.3345C91.0848 47.3245 91.2298 47.4545 91.2398 47.6195Z",
  fill: "#0E1010"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M112.75 119.595L115.03 122.625C115.405 123.08 115.415 123.73 115.05 124.2L111.39 128.91C111.155 129.215 110.81 129.41 110.43 129.465L105.19 130.2C103.57 130.43 102.595 128.365 104.08 127.46C105.995 126.29 107.245 124.205 108.22 122.245",
  fill: "#727D79"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M110.975 80.125L108.875 97.985L113.075 119.75L107.225 123.35L101.67 104.14L101.52 81.63",
  fill: "#ACACAC"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M102.535 123.38L101.485 129.27C101.305 129.91 100.655 130.355 99.91 130.355L88.535 130.375C86.28 130.375 85.695 127.605 87.81 126.92C87.84 126.91 87.87 126.9 87.9 126.89C90.93 125.955 95.615 124.05 95.615 124.05",
  fill: "#727D79"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M110.085 72.875C110.675 74.245 110.825 74.27 111.2 75.71C112.27 79.82 110.635 83.3 108.175 86.525C107.32 87.645 105.345 92.535 104.265 95.825C103.795 97.255 103.53 98.745 103.47 100.25L102.535 123.38L95.4349 124.05C95.3249 120.84 92.8799 100.495 92.8799 100.495C92.7549 99.19 92.7549 97.875 92.8799 96.57L94.9449 74.23",
  fill: "#D7D8D6"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M95.315 56.0499L95.075 56.2299C92.41 58.2049 91.155 61.5549 91.87 64.7899L94.54 76.9149L111.29 76.0099L107.86 60.0899C107.825 59.9699 107.785 59.8499 107.745 59.7349C105.97 54.6349 99.65 52.8349 95.315 56.0499Z",
  fill: "url(#paint0_linear_31451_21123)"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M102.295 85.4095L106.585 77.2395C107.625 75.2595 107.99 72.9995 107.625 70.7945L105.3 56.6045L98.855 57.6695L101.935 73.2545L99.36 81.7095L102.29 85.4095",
  fill: "#C1813E"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M102.255 54.9904C102.59 54.9904 102.935 55.0304 103.285 55.1154C105.005 55.5354 106.29 56.9703 106.52 58.7253L107.81 67.2253L99.3749 68.7754L98.0299 59.9504C97.9949 59.7154 97.9749 59.4854 97.9749 59.2554C97.9749 56.8954 99.9299 54.9854 102.25 54.9854",
  fill: "url(#paint1_linear_31451_21123)"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M103.34 87.0699C100.945 85.1749 98.9199 82.3749 98.5149 79.3099C98.4599 78.8799 99.1349 78.8849 99.1949 79.3099C99.5749 82.1849 101.585 84.8199 103.82 86.5949C104.16 86.8649 103.68 87.3399 103.34 87.0749V87.0699Z",
  fill: "#ACACAC"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M89.5349 51.6052C89.6099 51.5502 89.6899 51.5002 89.7749 51.4602C90.0649 51.3102 90.3499 51.2552 90.6199 51.2802",
  stroke: "#A3642B",
  strokeWidth: 0.75,
  strokeMiterlimit: 10
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M42.9249 79.6299L45.025 97.4849L40.825 119.25L46.68 122.85L52.2299 103.64L52.38 81.1299",
  fill: "#ACACAC"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M43.8149 72.375C43.2249 73.745 43.0749 73.77 42.6999 75.21C41.6299 79.32 43.2649 82.8 45.7249 86.025C46.5799 87.145 48.5549 92.035 49.6349 95.325C50.1049 96.755 50.3699 98.245 50.4299 99.75L51.3649 122.88L58.4649 123.55C58.5749 120.34 61.0199 99.995 61.0199 99.995C61.1449 98.69 61.1449 97.375 61.0199 96.07L58.9549 73.73",
  fill: "#D7D8D6"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M58.59 55.5548L58.83 55.7348C61.495 57.7098 62.75 61.0598 62.035 64.2948L59.365 76.4198L42.615 75.5148L46.045 59.5948C46.08 59.4748 46.12 59.3548 46.16 59.2398C47.935 54.1398 54.255 52.3398 58.59 55.5548Z",
  fill: "url(#paint2_linear_31451_21123)"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M51.605 84.9144L47.315 76.7444C46.275 74.7644 45.91 72.5044 46.275 70.2994L48.6 56.1094L55.045 57.1744L51.965 72.7594L54.54 81.2144L51.61 84.9144",
  fill: "#EBB990"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M51.6448 54.4894C51.3098 54.4894 50.9648 54.5294 50.6148 54.6144C48.8948 55.0344 47.6098 56.4694 47.3798 58.2244L46.0898 66.7244L54.5248 68.2744L55.8698 59.4494C55.9048 59.2144 55.9248 58.9844 55.9248 58.7544C55.9248 56.3944 53.9698 54.4844 51.6498 54.4844",
  fill: "url(#paint3_linear_31451_21123)"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M53.1649 54.145L59.2449 56.07L59.3099 56.06L59.9999 53.585L61.6049 54.05C62.8999 54.315 63.1599 52.85 63.3899 51.945C63.5699 51.24 63.7499 50.54 63.9249 49.835C64.1699 49.955 64.4949 50.06 64.6899 49.87C64.8149 49.75 64.8249 49.555 64.8249 49.38C64.8349 48.17 64.8449 46.955 64.6899 45.755C64.5299 44.555 64.1999 43.36 63.5649 42.33C63.0499 41.49 62.1149 41.42 61.1349 41.31C60.1549 41.2 59.1599 41.385 58.2349 41.735C57.6149 41.97 57.0199 42.285 56.5199 42.715C54.6649 44.3 54.0599 46.895 55.0849 49.095L53.1599 54.15",
  fill: "#EBB990"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6049 47.6551C62.5549 47.8151 62.6399 47.9801 62.7999 48.0301C62.9599 48.0801 63.1249 47.9951 63.1749 47.8351C63.2249 47.6751 63.1399 47.5101 62.9799 47.4601C62.8199 47.4101 62.6549 47.5001 62.6049 47.6551Z",
  fill: "#0E1010"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M59.9851 53.5801L57.5601 52.8301L59.5401 55.2301L59.9851 53.5801Z",
  fill: "#D98651"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M63.1899 50.9703C63.1049 50.9303 63.0199 50.8953 62.9299 50.8653C62.6199 50.7653 62.3299 50.7603 62.0649 50.8303",
  stroke: "#D98651",
  strokeWidth: 0.75,
  strokeMiterlimit: 10
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M55.0448 78.6445C54.6648 81.5195 52.6548 84.1545 50.4198 85.9295C50.0798 86.1995 50.5598 86.6745 50.8998 86.4095",
  stroke: "#ACACAC",
  strokeMiterlimit: 10
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M93.7501 46.1453C93.6351 45.5103 93.3501 45.0203 92.5101 44.7803C91.8501 44.5903 91.1501 44.5953 90.4801 44.4303C90.0201 44.3153 89.5801 44.1253 89.1851 43.8603C88.8601 43.6453 88.5651 43.3803 88.3401 43.0603C87.7201 42.1753 87.7501 40.9003 88.3901 40.0303C89.0251 39.1603 90.0001 38.7253 91.0301 39.0353C92.1151 39.3653 92.9151 40.2553 93.8451 40.9053C94.6301 41.4553 95.5301 41.8453 96.4701 42.0353C97.3601 42.2153 98.3201 42.2403 99.0801 42.7353C99.4851 43.0003 99.8051 43.3803 100.055 43.7953C100.825 45.0703 100.975 46.6653 100.65 48.1203C100.325 49.5953 99.4701 51.6103 97.6651 51.5903C96.8801 51.5803 96.1201 51.1203 95.7501 50.4303C96.2401 50.1853 96.7501 49.9253 97.0551 49.4703C97.3101 49.0853 97.3851 48.6003 97.3251 48.1403C97.2801 47.8053 97.1601 47.4753 96.9401 47.2153C96.6451 46.8653 96.1751 46.6753 95.7251 46.7103C95.2701 46.7503 94.8401 47.0203 94.6101 47.4153C94.5451 47.5253 94.4851 47.6553 94.3651 47.7103C94.2151 47.7753 94.0351 47.6853 93.9451 47.5503C93.8551 47.4153 93.8401 47.2403 93.8351 47.0803C93.8151 46.7503 93.8001 46.4353 93.7501 46.1503V46.1453Z",
  fill: "#0E1010"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M34.925 59.0553C34.515 57.7703 34.61 56.3303 35.355 55.2153C36.045 54.1853 37.215 53.2403 38.385 52.8353C39.61 52.4103 40.985 52.3453 42.065 51.5703C43.22 50.7403 43.735 49.2903 44.635 48.1853C45.31 47.3553 46.215 46.7153 47.225 46.3603C48.79 45.8053 50.625 45.9003 51.935 44.8803C53.055 44.0103 53.505 42.5503 54.37 41.4303C55.26 40.2803 56.405 39.6153 57.82 39.2953C59.03 39.0203 60.595 39.4803 61.61 40.2203C66.175 43.5603 61.735 43.0203 60.635 42.8203C59.8 42.6653 59.01 43.3103 58.165 43.4253L58.35 46.6503C57.83 46.2153 57.015 45.9303 56.43 46.2703C56.1 46.4653 55.89 46.8253 55.8 47.1953C55.565 48.1553 56.1 49.2403 57 49.6453C57.085 50.7603 56.455 51.9753 55.56 52.6353C55.14 52.9453 54.65 53.1553 54.265 53.5053C53.77 53.9603 53.5 54.6053 53.06 55.1103C51.12 57.3253 47.205 56.5553 45.27 58.8903C44.84 59.4053 44.57 60.0353 44.185 60.5803C43.24 61.9253 41.605 62.7453 39.96 62.7303C38.32 62.7153 36.71 61.8853 35.715 60.5803C35.37 60.1253 35.1 59.6053 34.93 59.0553H34.925Z",
  fill: "#8B5624"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M51.1951 122.635L58.2901 122.595C59.7551 125.045 61.5751 127.885 64.5001 128.715C64.9751 128.85 65.4751 128.925 65.9151 129.145C66.3601 129.365 66.7551 129.765 66.7901 130.26C66.8251 130.755 66.3501 131.265 65.8701 131.135L57.7201 130.81L55.6701 128.365L55.3101 130.715L52.9001 130.62L51.1851 122.64L51.1951 122.635Z",
  fill: "#3E4E48"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M46.59 122.535C46.27 124.195 46.96 125.89 48.35 126.86L49.45 127.63C50.145 128.115 49.755 129.205 48.91 129.145L42.56 128.675L40.87 126.75L40.975 123.815L39.725 125.72L38.49 124.775L40.94 118.97",
  fill: "#3E4E48"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6901 54.4746L92.1001 54.5146L92.9901 55.9596L94.6901 54.4746Z",
  fill: "#92410F"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_31451_21123",
  x1: 111.29,
  y1: 65.6799,
  x2: 91.67,
  y2: 65.6799,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_31451_21123",
  x1: 107.178,
  y1: 62.2253,
  x2: 95.8321,
  y2: 59.6101,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002E12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006C43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_31451_21123",
  x1: 42.61,
  y1: 65.1798,
  x2: 62.23,
  y2: 65.1798,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_31451_21123",
  x1: 46.8714,
  y1: 61.5524,
  x2: 58.0111,
  y2: 58.9847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00AF4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00D38D"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecklistEndReprove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checklist-end-reprove.4fd219d726fa650753397f648cc38f06.svg";